"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
class EntityId {
    constructor(name, key) {
        this.name = name;
        this.key = key;
        utils_1.Utils.throwIfEmpty(name, "name");
        utils_1.Utils.throwIfEmpty(key, "key");
    }
    static getEntityIdFromSchedulerId(schedulerId) {
        const pos = schedulerId.indexOf("@", 1);
        const entityName = schedulerId.substring(1, pos);
        const entityKey = schedulerId.substring(pos + 1);
        return new EntityId(entityName, entityKey);
    }
    static getSchedulerIdFromEntityId(entityId) {
        return `@${entityId.name.toLowerCase()}@${entityId.key}`;
    }
    toString() {
        return EntityId.getSchedulerIdFromEntityId(this);
    }
}
exports.EntityId = EntityId;
//# sourceMappingURL=entityid.js.map